import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Sidebar } from "./components/Sidebar";
import { Dashboard } from "./pages/Dashboard";
import { Conversations } from "./pages/Conversations";
import { BotConfig } from "./pages/BotConfig";
import { Bookings } from "./pages/Bookings";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#09090b",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "40px",
            height: "40px",
            border: "2px solid #e879a0",
            borderTopColor: "transparent",
            borderRadius: "50%",
            animation: "spin 0.7s linear infinite",
          }}
        />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={user ? <Navigate to="/" replace /> : <Login />}
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <div className="App flex min-h-screen bg-zinc-50">
              <Sidebar />
              <main className="flex-1 overflow-auto">
                <Dashboard />
              </main>
            </div>
          </ProtectedRoute>
        }
      />
      <Route
        path="/conversations"
        element={
          <ProtectedRoute>
            <div className="App flex min-h-screen bg-zinc-50">
              <Sidebar />
              <main className="flex-1 overflow-auto">
                <Conversations />
              </main>
            </div>
          </ProtectedRoute>
        }
      />
      <Route
        path="/bot-config"
        element={
          <ProtectedRoute>
            <div className="App flex min-h-screen bg-zinc-50">
              <Sidebar />
              <main className="flex-1 overflow-auto">
                <BotConfig />
              </main>
            </div>
          </ProtectedRoute>
        }
      />
      <Route
        path="/bookings"
        element={
          <ProtectedRoute>
            <div className="App flex min-h-screen bg-zinc-50">
              <Sidebar />
              <main className="flex-1 overflow-auto">
                <Bookings />
              </main>
            </div>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
